import React from "react";
import AdminAddUser from "../../Components/Admin/AdminAddUser";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddUserPage = ()=>{
    return (
      <AdminAddUser />
    )
}

export default AdminAddUserPage